import React from "react";
import { Autocomplete } from "@origin-digital/ods-lab";
import { useFormikContext, useField } from "formik";
import { styled } from "@mui/material";
// import { Autocomplete } from "src/components/Projects/AutoComplete";

export interface Option {
  label: string;
  value: string;
}

interface AutocompleteFieldProps {
  id: string;
  label: string;
  options: Option[];
  loading: boolean;
  field: {
    name: string;
    value: string | null;
    onChange: (e: React.ChangeEvent<any>) => void;
    onBlur: (e: React.FocusEvent<any>) => void;
  };
}

const StyledAutoComplete = styled(Autocomplete)({
  width: "100%",
});

const AutocompleteField: React.FC<AutocompleteFieldProps> = ({
  field: { name, value },
  id,
  label,
  options,
  loading,
}) => {
  const { setFieldValue } = useFormikContext();
  const [, { error }] = useField(name);
  const [inputValue, setInputValue] = React.useState("");

  return (
    <StyledAutoComplete
      id={id}
      textFieldProps={{
        variant: "outlined",
        hideHelperTextSpace: true,
      }}
      label={label}
      options={options}
      value={options.find((option) => option.value === value) || null}
      onChange={(_, item, reason) => {
        if (reason === "clear") {
          setFieldValue(name, null);
        } else {
          // @ts-expect-error: item is not correctly typed
          setFieldValue(name, item.value);
        }
      }}
      inputValue={inputValue}
      // @ts-expect-error: onInputChange is not correctly typed
      onInputChange={(event, tempValue, reason) => {
        if (reason === "clear") {
          return setInputValue("");
        }
        setInputValue(tempValue);
      }}
      error={!!error}
      helperText={error}
      loading={loading}
    />
  );
};

export default AutocompleteField;
